import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[formLandingBody]',
    standalone: false
})
export class FormLandingBodyDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}